export const minReportsTableColumnsWidth = {
  periodType: 150,
  scheduledAt: 150,
  status: 120,
  processingDate: 120,
  reportTemplateTaskHistoryId: 160,
  reportType: 160,
  activate: 100,
};
